<template>
  <div class="d-flex align-items-center">
    <span v-if="label"
          class="mb-0 mr-3"
          v-text="label" />
    <label :for="id"
           class="switch switch-3d switch-success mb-0">
      <input type="checkbox"
             :id="id"
             class="switch-input"
             v-model="localValue">
      <span class="switch-slider"></span>
    </label>
    <span v-if="trueLabel"
          class="mb-0 mr-3"
          v-text="trueLabel" />
  </div>
</template>

<script>
export default {
  name: "formFieldSwitch",
  props: {
    label: {
      type: String,
    },
    trueLabel: {
      type: String
    },
    value: {
      type: Boolean,
    },
    id: {
      type: String,
      default: ''
    },
  },
  computed: {
    localValue: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      }
    }
  }
}
</script>
